export function attachChooserButtons(root = document) {
    function onClick(e) {
        try {
            const el = e.currentTarget;
            if (el.classList.contains('loading')) return;
            e.preventDefault();
            e.stopPropagation();
            el.classList.add('loading');
            const lbl = el.querySelector('.label');
            if (lbl) lbl.style.display = 'none';
            if (!el.querySelector('.spinner-border')) {
                const s = document.createElement('span');
                s.className = 'spinner-border spinner-border-sm';
                s.setAttribute('role', 'status');
                s.setAttribute('aria-hidden', 'true');
                el.insertBefore(s, el.firstChild);
            }
            // allow spinner to render
            requestAnimationFrame(() => setTimeout(() => {
                window.location.href = el.getAttribute('data-href') || el.href;
            }, 120));
        } catch (err) {
            console.error('chooser onClick error', err);
            const el = e && e.currentTarget;
            const href = el && (el.getAttribute('data-href') || el.href);
            if (href) window.location.href = href;
        }
    }

    // attach to existing elements
    const els = root.querySelectorAll('a.spinner-btn, button.spinner-btn');
    els.forEach(el => {
        el.removeEventListener('click', onClick);
        el.addEventListener('click', onClick);
    });
}

export function resetChooserButtons(root = document) {
    try {
        const els = root.querySelectorAll('a.spinner-btn, button.spinner-btn');
        els.forEach(el => {
            // remove loading class
            if (el.classList.contains('loading')) el.classList.remove('loading');
            // show label
            const lbl = el.querySelector('.label');
            if (lbl) lbl.style.display = '';
            // remove spinner elements
            const spinners = el.querySelectorAll('.spinner-border');
            spinners.forEach(s => s.remove());
        });
    } catch (err) {
        console.error('resetChooserButtons error', err);
    }
}

// Auto-attach on DOMContentLoaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        attachChooserButtons(document);
        resetChooserButtons(document);
    });
} else {
    attachChooserButtons(document);
    resetChooserButtons(document);
}

// When HTMX swaps content we'll re-attach in index.js; but also clear loading on navigation events
window.addEventListener('pageshow', function () {
    // pageshow fires when a page is restored from bfcache (evt.persisted === true)
    resetChooserButtons(document);
});

window.addEventListener('popstate', function () {
    // back/forward navigation
    resetChooserButtons(document);
});

// If the page becomes visible again, ensure buttons are reset
window.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
        resetChooserButtons(document);
    }
});
